<!-- eslint-disable max-len -->
<template>
  <div>
    <h4>TUNJANGAN</h4>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="$refs.modalCreate.show()">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
        </b-form>
      </div>

      <div
        slot="nominat"
        slot-scope="props">
        <j-currency
          :value="Number(props.row.nominat)"
          :options="exampleOptionCurrency"/>
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-modal
      ref="modalCreate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Data Tunjangan</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.jenis.$error}">
            <label> Jenis Tunjangan </label>
            <j-input
              v-model="$v.data_master.jenis.$model"
              placeholder="Jenis Tunjangan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.nama.$error}">
            <label> Nama Tunjangan </label>
            <j-input
              v-model="$v.data_master.nama.$model"
              placeholder="Nama Tunjangan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.instansi.$error}">
            <label> Instansi </label>
            <j-input
              v-model="$v.data_master.instansi.$model"
              placeholder="Instansi"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.sk_tunjangan.$error}">
            <label> SK Tunjangan </label>
            <j-input
              v-model="$v.data_master.sk_tunjangan.$model"
              placeholder="SK Tunjangan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tanggal_sk_tunjangan.$error}">
            <label> Tanggal SK Tunjangan </label>
            <j-datepicker
              v-model="$v.data_master.tanggal_sk_tunjangan.$model"
              placeholder="Tanggal SK Tunjangan"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.semester.$error}">
            <label> Semester </label>
            <j-single-select
              v-model="$v.data_master.semester.$model"
              :options="list_semester"
              placeholder="Pilih Semester"
              label="name"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.sumber_dana.$error}">
            <label> Sumber Dana </label>
            <j-input
              v-model="$v.data_master.sumber_dana.$model"
              placeholder="Sumber Dana"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.dari_tahun.$error}">
            <label> Dari Tahun </label>
            <j-input
              v-model="$v.data_master.dari_tahun.$model"
              type="number"
              placeholder="Dari Tahun"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.sampai_tahun.$error}">
            <label> Sampai Tahun </label>
            <j-input
              v-model="$v.data_master.sampai_tahun.$model"
              type="number"
              placeholder="Sampai Tahun"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.nominal.$error}">
            <label> Nominal </label>
            <j-currency
              v-model="$v.data_master.nominal.$model"
              :options="exampleOptionCurrency"
              :input_mode="true"
              placeholder="Nominal"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.status.$error}">
            <label> Status </label>
            <j-input
              v-model="$v.data_master.status.$model"
              placeholder="Status"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Update Data Tunjangan</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.jenis.$error}">
            <label> Jenis Tunjangan </label>
            <j-input
              v-model="$v.data_master.jenis.$model"
              :disabled="readOnly"
              placeholder="Jenis Tunjangan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.nama.$error}">
            <label> Nama Tunjangan </label>
            <j-input
              v-model="$v.data_master.nama.$model"
              :disabled="readOnly"
              placeholder="Nama Tunjangan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.instansi.$error}">
            <label> Instansi </label>
            <j-input
              v-model="$v.data_master.instansi.$model"
              :disabled="readOnly"
              placeholder="Instansi"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.sk_tunjangan.$error}">
            <label> SK Tunjangan </label>
            <j-input
              v-model="$v.data_master.sk_tunjangan.$model"
              :disabled="readOnly"
              placeholder="SK Tunjangan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tanggal_sk_tunjangan.$error}">
            <label> Tanggal SK Tunjangan </label>
            <j-datepicker
              v-model="$v.data_master.tanggal_sk_tunjangan.$model"
              :disabled="readOnly"
              placeholder="Tanggal SK Tunjangan"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.semester.$error}">
            <label> Semester </label>
            <j-single-select
              v-model="$v.data_master.semester.$model"
              :disabled="readOnly"
              :options="list_semester"
              placeholder="Pilih Semester"
              label="name"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.sumber_dana.$error}">
            <label> Sumber Dana </label>
            <j-input
              v-model="$v.data_master.sumber_dana.$model"
              :disabled="readOnly"
              placeholder="Sumber Dana"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.dari_tahun.$error}">
            <label> Dari Tahun </label>
            <j-input
              v-model="$v.data_master.dari_tahun.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Dari Tahun"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.sampai_tahun.$error}">
            <label> Sampai Tahun </label>
            <j-input
              v-model="$v.data_master.sampai_tahun.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Sampai Tahun"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.nominal.$error}">
            <label> Nominal </label>
            <j-currency
              v-model="$v.data_master.nominal.$model"
              :options="exampleOptionCurrency"
              :input_mode="true"
              :disabled="readOnly"
              placeholder="Nominal"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.status.$error}">
            <label> Status </label>
            <j-input
              v-model="$v.data_master.status.$model"
              :disabled="readOnly"
              placeholder="Status"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="6">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKurikulum from '@/services/jApiKurikulum';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  // eslint-disable-next-line
  name: 'jTunjangan',
  components: {
    jLoadingTable,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      load_first: false,
      data_table: [],
      selected_rows: [],
      columns: ['jenis', 'nama', 'instansi', 'sk_tunjangan', 'tanggal_sk_tunjangan', 'semester', 'sumber_dana', 'dari_tahun', 'sampai_tahun', 'nominat', 'status'],
      options: {
        headings: {
          jenis: 'JENIS TUNJANGAN',
          nama: 'NAMA TUNJANGAN',
          instansi: 'INSTANSI',
          sk_tunjangan: 'SK TUNJANGAN',
          tanggal_sk_tunjangan: 'TANGGAL SK TUNJANGAN',
          semester: 'SEMESTER',
          sumber_dana: 'SUMBER DANA',
          dari_tahun: 'DARI TAHUN',
          sampai_tahun: 'SAMPAI TAHUN',
          nominat: 'NOMINAL',
          status: 'STATUS',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: ['jenis', 'nama', 'instansi', 'sk_tunjangan', 'tanggal_sk_tunjangan', 'semester', 'sumber_dana', 'dari_tahun', 'sampai_tahun', 'nominat', 'status'],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            id_pegawai: data.id_pegawai,
          };
        },
        requestFunction(data) {
          const getList = jApiKurikulum.getListTunjangan(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },

      data_master: {
        id_pegawai: this.$route.params.id,
        jenis: '',
        nama: '',
        instansi: '',
        sk_tunjangan: '',
        tanggal_sk_tunjangan: null,
        semester: null,
        sumber_dana: '',
        dari_tahun: null,
        sampai_tahun: null,
        nominal: null,
        status: '',
      },
      exampleOptionCurrency: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        currencySymbol: 'Rp',
        currencySymbolPlacement: 'p',
        roundingMethod: 'U',
        minimumValue: '0',
        maximumValue: '99999999999999',
      },
      list_semester: [
        {
          id: 'Ganjil',
          name: 'Ganjil',
        },
        {
          id: 'Genap',
          name: 'Genap',
        },
      ],
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKurikulum', ['createTunjangan', 'updateTunjangan', 'deleteTunjangan']),

    loading(val) {
      const a = val;
      a.id_pegawai = this.$route.params.id;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    closeModalCreate() {
      this.$refs.modalCreate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        jenis: '',
        nama: '',
        instansi: '',
        sk_tunjangan: '',
        tanggal_sk_tunjangan: null,
        semester: null,
        sumber_dana: '',
        dari_tahun: null,
        sampai_tahun: null,
        nominal: null,
        status: '',
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        jenis: '',
        nama: '',
        instansi: '',
        sk_tunjangan: '',
        tanggal_sk_tunjangan: null,
        semester: null,
        sumber_dana: '',
        dari_tahun: null,
        sampai_tahun: null,
        nominal: null,
        status: '',
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.$refs.modalUpdate.show();
      this.data_master = {
        id: param.row.id,
        id_pegawai: param.row.id_pegawai,
        jenis: param.row.jenis,
        nama: param.row.nama,
        instansi: param.row.instansi,
        sk_tunjangan: param.row.sk_tunjangan,
        tanggal_sk_tunjangan: param.row.tanggal_sk_tunjangan,
        semester: param.row.semester,
        sumber_dana: param.row.sumber_dana,
        dari_tahun: param.row.dari_tahun,
        sampai_tahun: param.row.sampai_tahun,
        nominal: Number(param.row.nominat),
        status: param.row.status,
      };
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const params = this.data_master;
        params.tanggal_sk_tunjangan = params.tanggal_sk_tunjangan ? this.$moment(params.tanggal_sk_tunjangan).format('YYYY-MM-DD') : '';
        this.createTunjangan(params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalCreate();
            }, 1500);
          }
        });
      }
    },

    updateData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const params = this.data_master;
        params.tanggal_sk_tunjangan = params.tanggal_sk_tunjangan ? this.$moment(params.tanggal_sk_tunjangan).format('YYYY-MM-DD') : '';
        this.updateTunjangan(params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalUpdate();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deleteTunjangan(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      data_master: {
        jenis: { required },
        nama: { required },
        instansi: { required },
        sk_tunjangan: { required },
        tanggal_sk_tunjangan: { required },
        semester: { required },
        sumber_dana: { required },
        dari_tahun: { required },
        sampai_tahun: { required },
        nominal: { required },
        status: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/tab-component/jTunjangan.vue